import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=71fdc6ec&scoped=true"
import script from "./ImageBox.vue?vue&type=script&lang=js"
export * from "./ImageBox.vue?vue&type=script&lang=js"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=71fdc6ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdc6ec",
  null
  
)

export default component.exports